import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';

import Table from './table';
import { Paper, Button, Typography } from '@mui/material';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const PREFIX = 'Activities';

const classes = {
    paper: `${PREFIX}-paper`,
    topbar: `${PREFIX}-topbar`,
    searchbar: `${PREFIX}-searchbar`,
    multicheckboxFilter: `${PREFIX}-multicheckboxFilter`,
    formControl: `${PREFIX}-formControl`,
    filterSummary: `${PREFIX}-filterSummary`,
    stage_options: `${PREFIX}-stage_options`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        width: '65vw',
        [theme.breakpoints.up('sm')]: {
            width: 'auto'
        },
        // maxWidth: '95vw',
        // minHeight: '70vh',
        maxHeight:  Math.round(window.innerWidth * 0.9),
        // paddingBottom: '1rem',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'clip',
        overflowX: 'hidden',
    },

    [`& .${classes.topbar}`]: {
        display: 'flex',
        padding: '1rem',
        paddingBottom: '0rem',
    },

    [`& .${classes.searchbar}`]: {
        display: 'inline-flex',
        alignItems: 'flex-end'
    },

    [`& .${classes.multicheckboxFilter}`]: {
      width: '200px',
      paddingBottom: '1rem',
      display: 'inline-block',
    },

    [`& .${classes.formControl}`]: {
      minWidth: '17.5vw',
      maxWidth: 400
    },

    [`& .${classes.filterSummary}`]: {
      maxWidth: '60vw'  
      },

    [`& .${classes.stage_options}`]: {
      '&.MuiInputBase': {
        margin: '0px',
      },
      '&.MuiSelect-icon': {
        display: 'none',
      }
    }
}));

// Styles for the React Table
const Styles = styled('div')({
    padding: '1rem',
    paddingBottom: 0,
    '& .table': {
        display: 'flow-root',
        borderSpacing: 0,
        border: '1px solid black',
        borderLeft: 0,
        fontFamily: 'Roboto',
        '& .tr:last-child .td': {
            borderBottom: '1px solid black',
        },
        '& .th': {
            textAlign: 'left',
            background: '#093d61',
            color: 'white',
            height: '2.5rem',
            padding: '0.5rem',
            borderBottom: '1px solid black',
            borderRight: '1px solid black',
        },
        '& .td': {
            position: 'relative',
            margin: 0,
            padding: '0.4rem',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            borderLeft: '1px solid black',
            borderBottom: '1px solid #d1d5da',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            '& .resizer': {
                display: 'inline-block',
                width: 7,
                height: '100%',
                position: 'absolute',
                right: 0,
                top: 0,
                transform: 'translateX(50%)',
                zIndex: 1,
                touchAction: 'none',
            },
        },
    },
});

//Function that pulls the data and sends it to the Table Renderer
const Activities = props => {
    let { loading, activity_view_data, updateLLViewSettings, collapsed_activities, selectedActivities, setSelectedActivities} = props;

    const rem_value = Math.round(window.innerWidth)/100;

    var hiddenColumns = ['id','has_children', 'ancestry'];

    // Data being fed to the table
    const [activityViewData, setActivityViewData] = useState(activity_view_data)

    useEffect(() => {
        setActivityViewData(activity_view_data)
    },[activity_view_data])

    const columns = React.useMemo(() => [
        {
            id: 'id',
            accessorKey: 'id',
            header: 'id',
            size: 5*rem_value,
        },
        {
            id: 'selector',
            accessorKey: 'selector',
            header: 'Selector',
            size: 110,
            enableColumnFilter: false,
            cell: (info) => {
                const rowId = info.row.original.id;
                const [value, setValue] = useState(selectedActivities.includes(parseInt(rowId)) ? 'selected' : 'select');

                return(
                    <div
                        onClick={() => {
                            const id = parseInt(rowId);
                            if (value !== 'selected') {
                                setValue('selected');
                                setSelectedActivities(prev => [...prev, id])
                            } else {
                                setValue('select');
                                setSelectedActivities(prev => prev.filter(e => e !== id))
                            }
                        }}
                    >
                        <Button
                            variant={value === 'selected' ? 'contained' : 'outlined'}
                            style={{backgroundColor: value==='selected' ? '#22ba43' : '#FFFFFF', outline: '#2f2f2f solid 1px',  maxHeight: '1rem', width: '4rem'} }
                        >
                            {value}
                        </Button>
                    </div>
                )
            },
        },
        {
            id: 'ancestry',
            accessorKey: 'ancestry',
            header: 'Ancestry',
            size: 10*rem_value,
        },
        {
            id: 'has_children',
            accessorKey: 'has_children',
            header: 'Has Children',
            size: 10*rem_value,
        },
        {
            id: 'title',
            accessorKey: 'title',
            header: 'Activity',
            size: 300,
            cell: (info) => {
                let space = [];
                if (info.row.original.ancestry) {
                    space = info.row.original.ancestry.split(',')
                }
                return (
                    <div
                        style={{display: 'flex', cursor: 'pointer'}}
                    >
                        {info.row.original.has_children ?
                            collapsed_activities.includes(info.row.original.id) ?
                                (<ArrowRightIcon onClick={() => updateLLViewSettings('activity_collapse', info.row.original.id)} />)
                                :
                                (<ArrowDropDownIcon onClick={() => updateLLViewSettings('activity_collapse', info.row.original.id)}/>)
                            :
                            <Root>&emsp;&ensp;</Root>
                        }
                        <div
                            onClick={() => updateLLViewSettings('activity_collapse', info.row.original.id)}
                            style={{display: 'flex', alignItems: 'center', minWidth: '100%'}}
                        >
                        {space.map((e, i) =>
                            <React.Fragment key={i}>&ensp;</React.Fragment>
                        )}
                        {info.getValue()}
                        <span style={{color: 'gray', fontSize: 'smaller'}}><i>&nbsp;{info.row.original.link_activity.length}</i></span>
                        </div>
                    </div>
                );
            },
        },
    ], []);

    return (
        <>
            {loading ? (
                <>
                <div style={{ position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <Typography variant='subtitle1'>Loading...</Typography>
                </div>
                </>
            ) : (
                <Paper elevation={1} className={classes.paper} id='activity_view'
                >
                    <div className={classes.topbar}>
                            <Typography variant='subtitle1'>Selected:&nbsp;{selectedActivities.length}</Typography>
                    </div>

                    <Styles>
                        <Table
                            columns={columns}
                            data={activityViewData}
                            hiddenColumns={hiddenColumns}
                            updateLLViewSettings={updateLLViewSettings}
                            getCellProps={cell => {
                                const isActivityColumn = cell.column.id === 'title';
                                const ancestry = cell.row.original.ancestry;
                                const ancestryCount = ancestry != null ? ancestry.split(',').length : 0;
                                const spectrum = ['#A9D0DD','#c5e4ed', '#d8edf3', '#ECF6F9', '#FFFFFF']
                                let bgcolor = ''
                                let fontcolor = ''
                                if (isActivityColumn) {
                                    bgcolor = spectrum[ancestryCount];
                                    fontcolor = 'black'
                                }
                                return {
                                    style: {
                                        backgroundColor: bgcolor,
                                        color: fontcolor
                                    },
                                }
                            }}
                      
                        />
                    </Styles>
                </Paper>
            )}
        </>
    );
};

export default Activities;